module.exports = __webpack_public_path__ + "img/banner.12a18a06.png";